module.exports = __webpack_public_path__ + "img/00034.aa367895.webp";